import { vars } from '@croquiscom-pvt/zds/tokens';
import styled from '@emotion/styled';

import { CreatorCouponRegister } from '../components/Coupon/CreatorCouponRegister';
import { useCreatorCouponService } from '../services/useCreatorCouponService';

export interface CreatorCouponContainerProps {}

export const CreatorCouponContainer: React.FC<React.PropsWithChildren<CreatorCouponContainerProps>> = () => {
  const { should_hide_creator_coupon, moveToCouponRegisterPage } = useCreatorCouponService();

  if (should_hide_creator_coupon) {
    return null;
  }

  return (
    <FloatingContainer>
      <CreatorCouponRegister
        buttonColor={vars.color.accentPinkPrimary}
        moveToCouponRegisterPage={moveToCouponRegisterPage}
      />
    </FloatingContainer>
  );
};

const FloatingContainer = styled.div`
  position: fixed;
  left: 50%;
  bottom: 88px;
  bottom: calc(constant(safe-area-inset-bottom) + 88px);
  bottom: calc(env(safe-area-inset-bottom) + 88px);
  transform: translateX(-50%);
  z-index: 201;
`;
